export var SystemMsgType;
(function (SystemMsgType) {
    SystemMsgType["RAISE_HAND"] = "RAISE_HAND";
    SystemMsgType["LOWER_HAND"] = "LOWER_HAND";
    SystemMsgType["OTHER_USER_LOWER_HAND"] = "OTHER_USER_LOWER_HAND";
    SystemMsgType["FILE_UPLOAD"] = "FILE_UPLOAD";
    SystemMsgType["INFO"] = "INFO";
    SystemMsgType["ALERT"] = "ALERT";
    SystemMsgType["SEND_CHAT_MSGS"] = "SEND_CHAT_MSGS";
    SystemMsgType["RENEW_TOKEN"] = "RENEW_TOKEN";
    SystemMsgType["UPDATE_LOCK_SETTINGS"] = "UPDATE_LOCK_SETTINGS";
    SystemMsgType["INIT_WHITEBOARD"] = "INIT_WHITEBOARD";
    SystemMsgType["USER_VISIBILITY_CHANGE"] = "USER_VISIBILITY_CHANGE";
    SystemMsgType["EXTERNAL_MEDIA_PLAYER_EVENTS"] = "EXTERNAL_MEDIA_PLAYER_EVENTS";
    SystemMsgType["POLL_CREATED"] = "POLL_CREATED";
    SystemMsgType["NEW_POLL_RESPONSE"] = "NEW_POLL_RESPONSE";
    SystemMsgType["POLL_CLOSED"] = "POLL_CLOSED";
    SystemMsgType["JOIN_BREAKOUT_ROOM"] = "JOIN_BREAKOUT_ROOM";
})(SystemMsgType || (SystemMsgType = {}));
